import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CompanyFlagHistoryCompositeEntity, isCompanyFlagHistoryCompositeArray } from '@nk/data-entities-lib';
import { NkDatatableAbstractColumnComponent } from '@nk/ui-lib';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompanyFlagIconComponent } from '../company-flag-icon/company-flag-icon.component';

@Component({
  selector: 'nk-company-flag-composite-column',
  imports: [CommonModule, TooltipModule, TranslateModule, CompanyFlagIconComponent], // CompanyFlagIconComponent
  templateUrl: './company-flag-composite-column.component.html',
  styleUrls: ['./company-flag-composite-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyFlagCompositeColumnComponent<T> extends NkDatatableAbstractColumnComponent<T> {
  public companyFlagHistoryComposites$: Observable<CompanyFlagHistoryCompositeEntity[] | null> = this.value$.pipe(
    map((value) => {
      if (value && value.row && value.prop) {
        const items = value.row && value.row[value.prop];
        return isCompanyFlagHistoryCompositeArray(items) ? items : null;
      }
      return null;
    }),
  );
}
